import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/Layouts.vue'
import otherRouter from '@/router/modules/others'
import instancesRouter from '@/router/modules/instances'
// import store from '@/stores'
Vue.use(Router)

let routes = []

let rootRouter = {
  path: '/',
  component: layout,
  children: [],
  redirect: '/instances/list'
}

let redirectRouter = {
  path: '*',
  redirect: '/error'
}

otherRouter(rootRouter.children)
instancesRouter(rootRouter.children)

const router = new Router({
  mode: 'history',
  routes: routes.concat([rootRouter, redirectRouter])
})

export default router
